import styled, { css } from "styled-components";

import { Card } from "react-bootstrap";

export const MainCard = styled(Card)``;
export const MainImg = styled(Card.Img)``;

export const MainBody = styled(Card.Body)``;
export const MainTitle = styled(Card.Title)``;
export const MainText = styled(Card.Text)``;

export const IconImg = styled.img``;
